import * as Types from '../../../../../types/types.generated';

import { gql } from '@apollo/client';
import { KeywordTagFieldsFragmentDoc } from '../../../../../fragments/keywordTagFields.generated';
export type RequirementFieldsForListOfPageOfEntityLikeAProjectFragment = { __typename?: 'Requirement', id: string, name: string, requirementId?: string | null, category: Types.RequirementCategory, status: Types.RequirementStatus, definition?: string | null, modifiedAt?: any | null, createdAt?: any | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string } }> | null, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', id: string, name: string } | null, requirementReferences: Array<{ __typename?: 'Requirement', id: string, name: string }> }> | null, aggregatedFields: { __typename?: 'AggregatedFields', vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }> }, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export const RequirementFieldsForListOfPageOfEntityLikeAProjectFragmentDoc = gql`
    fragment RequirementFieldsForListOfPageOfEntityLikeAProject on Requirement {
  id
  name
  requirementId
  category
  vexClusters {
    id
    name
  }
  status
  definition
  systemLevels {
    id
    name
    createdAt
    createdBy {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
    modifiedAt
    modifiedBy {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
  }
  markets {
    id
    name
  }
  createdBy {
    givenName
    id
    mail
    name
    surname
    userPrincipalName
  }
  modifiedAt
  modifiedBy {
    givenName
    id
    mail
    name
    surname
    userPrincipalName
  }
  driveVariants {
    id
    name
  }
  engineVariants {
    id
    name
  }
  gearboxVariants {
    id
    name
  }
  bodyworkVariants {
    id
    name
  }
  activeTypeMarkets {
    id
    name
  }
  vehicleCategories {
    id
    name
  }
  keywords {
    ...KeywordTagFields
  }
  attachments {
    attachmentId
    file {
      uri
      contentType
      fileName
    }
  }
  documentReferences {
    referenceDocumentType
    reference {
      id
      name
    }
    requirementReferences {
      id
      name
    }
  }
  createdAt
  aggregatedFields {
    vehicleCategories {
      id
      name
    }
  }
  tags {
    id
    name
  }
}
    ${KeywordTagFieldsFragmentDoc}`;